/* ===================================================
   KENJIN TITANIUM SALES PAGE JAVASCRIPT
   Interactive Gallery, Bundle Calculator, FAQ, Timer
=================================================== */

document.addEventListener('DOMContentLoaded', () => {
  
  // 0. LOCATION & LOCALE ENGINE (FR <-> EN)
  function getDetectedLocale() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramLang = urlParams.get('lang') || urlParams.get('locale');
    if (paramLang && (paramLang.toLowerCase() === 'en' || paramLang.toLowerCase() === 'fr')) {
      return paramLang.toLowerCase();
    }
    
    // Explicit user preference from switcher
    const saved = localStorage.getItem('kenjin_locale');
    if (saved && (saved === 'en' || saved === 'fr')) {
      return saved;
    }
    
    // CRITICAL GOOGLE ADS PROTECTION:
    // If arriving from live French Google Ads (gclid / gad_source / etc) and no explicit lang=en is set,
    // ALWAYS stay 100% French to protect the active live campaign and Google review bots!
    const isGoogleAd = urlParams.has('gclid') || urlParams.has('gad_source') || urlParams.has('gbraid') || urlParams.has('wbraid');
    const isBot = /bot|googlebot|adsbot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
    if (isGoogleAd || isBot) {
      return 'fr';
    }

    // Check Shopify edge CDN country detection
    const country = window.Shopify && window.Shopify.country ? window.Shopify.country.toUpperCase() : null;
    if (country) {
      const francophone = ['FR', 'BE', 'CH', 'LU', 'MC', 'DZ', 'MA', 'TN', 'SN', 'CI'];
      if (francophone.includes(country)) return 'fr';
      const anglo = ['US', 'CA', 'GB', 'AU', 'NZ', 'IE'];
      if (anglo.includes(country)) return 'en';
      return 'fr'; // Safe default for all other regions
    }

    // Default URL is ALWAYS French
    return 'fr';
  }

  // Helper to check if cookie banner should be disabled (US or explicit parameter)
  function shouldDisableCookieBanner(lang) {
    const p = new URLSearchParams(window.location.search);
    if (p.has('nocookie') || p.has('nocookies') || p.get('cookies') === '0' || p.get('cookie') === '0' || p.get('privacy') === '0' || p.get('banner') === '0') {
      return true;
    }
    return lang === 'en';
  }

  function handleCookieBanner(lang) {
    const disable = shouldDisableCookieBanner(lang);
    if (disable) {
      document.documentElement.classList.add('no-cookie-banner');
      document.body.classList.add('no-cookie-banner');
      const banners = document.querySelectorAll('shopify-privacy-banner-element, #shopify-privacy-banner, .shopify-privacy-banner, [id*="shopify-pc"], .shopify-pc__banner');
      banners.forEach(b => b.remove());
      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent(true, () => {});
      }
    } else {
      const p = new URLSearchParams(window.location.search);
      const forced = p.has('nocookie') || p.has('nocookies') || p.get('cookies') === '0' || p.get('cookie') === '0' || p.get('privacy') === '0' || p.get('banner') === '0';
      if (!forced) {
        document.documentElement.classList.remove('no-cookie-banner');
        document.body.classList.remove('no-cookie-banner');
      }
    }
  }

  function applyLocale(lang) {
    localStorage.setItem('kenjin_locale', lang);
    document.documentElement.lang = lang;
    
    if (lang === 'en') {
      document.documentElement.classList.add('lang-en');
      document.documentElement.classList.remove('lang-fr');
      document.body.classList.add('lang-en');
      document.body.classList.remove('lang-fr');
    } else {
      document.documentElement.classList.add('lang-fr');
      document.documentElement.classList.remove('lang-en');
      document.body.classList.add('lang-fr');
      document.body.classList.remove('lang-en');
    }

    // Cookie Banner Manager
    handleCookieBanner(lang);


    // 1. Text elements with data-loc-fr and data-loc-en
    document.querySelectorAll('[data-loc-fr]').forEach(el => {
      const target = lang === 'en' ? el.getAttribute('data-loc-en') : el.getAttribute('data-loc-fr');
      if (target) {
        el.innerHTML = target;
      }
    });

    // 2. Images with data-src-fr and data-src-en
    document.querySelectorAll('img[data-src-fr]').forEach(img => {
      const newSrc = lang === 'en' ? img.getAttribute('data-src-en') : img.getAttribute('data-src-fr');
      if (newSrc && img.getAttribute('src') !== newSrc) {
        img.src = newSrc;
      }
    });

    // 3. Gallery Thumbnails data-src
    document.querySelectorAll('.thumb-item[data-src-fr]').forEach(thumb => {
      const newSrc = lang === 'en' ? thumb.getAttribute('data-src-en') : thumb.getAttribute('data-src-fr');
      if (newSrc) {
        thumb.setAttribute('data-src', newSrc);
        const innerImg = thumb.querySelector('img');
        if (innerImg) innerImg.src = newSrc;
      }
    });

    // Update main image to match active thumbnail's new locale src
    const activeThumb = document.querySelector('.thumb-item.active');
    const mainProductImg = document.getElementById('main-product-img');
    if (activeThumb && mainProductImg) {
      const activeSrc = activeThumb.getAttribute('data-src');
      if (activeSrc) mainProductImg.src = activeSrc;
    }

    // 4. Update switcher buttons UI
    document.querySelectorAll('.lang-switcher-btn').forEach(btn => {
      if (btn.getAttribute('data-lang') === lang) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // 5. Update bundle CTA text
    const heroCta = document.getElementById('hero-cta-btn');
    const activeCard = document.querySelector('.bundle-card.selected');
    const discount = activeCard ? activeCard.getAttribute('data-discount') || '-60%' : '-60%';
    if (heroCta) {
      const frSpan = heroCta.querySelector('.lang-fr-only');
      const enSpan = heroCta.querySelector('.lang-en-only');
      if (frSpan) frSpan.textContent = `RÉCLAMER MON OFFRE (${discount})`;
      if (enSpan) enSpan.textContent = `CLAIM MY OFFER (${discount})`;
      const singleSpan = heroCta.querySelector('span:not(.lang-fr-only):not(.lang-en-only)');
      if (singleSpan) {
        if (document.body.classList.contains('search-lander')) {
          singleSpan.textContent = lang === 'en' ? `ORDER NOW (${discount})` : `COMMANDER MAINTENANT (${discount})`;
        } else {
          singleSpan.textContent = lang === 'en' ? `CLAIM MY OFFER (${discount})` : `RÉCLAMER MON OFFRE (${discount})`;
        }
      }
    }
  }

  window.setKenjinLocale = applyLocale;

  // Initialize detected locale
  const currentLocale = getDetectedLocale();
  applyLocale(currentLocale);

  // Bind Switcher Buttons
  document.querySelectorAll('.lang-switcher-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const targetLang = btn.getAttribute('data-lang');
      if (targetLang) {
        applyLocale(targetLang);
      }
    });
  });

  // 1. GALLERY IMAGE SWITCHER
  const mainImg = document.getElementById('main-product-img');
  const thumbs = document.querySelectorAll('.thumb-item');
  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');
  let currentIdx = 0;

  function switchImage(index) {
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    currentIdx = index;

    thumbs.forEach(t => t.classList.remove('active'));
    thumbs[currentIdx].classList.add('active');

    const targetSrc = thumbs[currentIdx].getAttribute('data-src');
    mainImg.style.opacity = '0.5';
    setTimeout(() => {
      mainImg.src = targetSrc;
      mainImg.style.opacity = '1';
    }, 150);
  }

  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', () => switchImage(idx));
  });

  if (prevBtn) prevBtn.addEventListener('click', () => switchImage(currentIdx - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => switchImage(currentIdx + 1));

  // 2. BUNDLE SELECTOR & DYNAMIC PRICING & SHOPIFY CHECKOUT
  const bundleCards = document.querySelectorAll('.bundle-card');
  const heroCtaBtn = document.getElementById('hero-cta-btn');
  const floatingCtaBtn = document.querySelector('.floating-cta-btn');
  
  // Default selected variant (Option 2: 2x Duo Chef - Best Seller)
  let selectedVariantId = '58041319293310';

  bundleCards.forEach(card => {
    if (card.classList.contains('selected')) {
      selectedVariantId = card.getAttribute('data-variant-id') || selectedVariantId;
    }

    card.addEventListener('click', () => {
      bundleCards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');
      const radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      selectedVariantId = card.getAttribute('data-variant-id') || selectedVariantId;
      const discount = card.getAttribute('data-discount') || '-60%';
      const isEnglish = document.documentElement.lang === 'en' || document.body.classList.contains('lang-en');
      
      if (heroCtaBtn) {
        const frSpan = heroCtaBtn.querySelector('.lang-fr-only');
        const enSpan = heroCtaBtn.querySelector('.lang-en-only');
        if (frSpan) frSpan.textContent = `RÉCLAMER MON OFFRE (${discount})`;
        if (enSpan) enSpan.textContent = `CLAIM MY OFFER (${discount})`;
        const singleSpan = heroCtaBtn.querySelector('span:not(.lang-fr-only):not(.lang-en-only)');
        if (singleSpan) {
          if (isEnglish) {
            singleSpan.textContent = `ORDER NOW (${discount})`;
          } else if (document.body.classList.contains('search-lander')) {
            singleSpan.textContent = `COMMANDER MAINTENANT (${discount})`;
          } else {
            singleSpan.textContent = `RÉCLAMER MON OFFRE (${discount})`;
          }
        }
      }
    });
  });

  // Direct Shopify Checkout Handler
  function proceedToCheckout(btnElement) {
    if (!selectedVariantId) return;
    const isEnglish = document.documentElement.lang === 'en' || document.body.classList.contains('lang-en');

    if (btnElement) {
      btnElement.style.pointerEvents = 'none';
      btnElement.style.opacity = '0.85';
      const span = btnElement.querySelector('span') || btnElement;
      span.textContent = isEnglish ? 'PROCEEDING TO SECURE CHECKOUT...' : 'REDIRECTION VERS LE PAIEMENT...';
    }

    // Use Shopify AJAX Cart API: clear old items, add selected bundle variant, redirect to checkout
    fetch('/cart/clear.js', { method: 'POST' })
      .catch(() => {})
      .then(() => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: selectedVariantId,
              quantity: 1
            }]
          })
        });
      })
      .then(res => res.json())
      .then(() => {
        window.location.href = isEnglish ? '/checkout?locale=en' : '/checkout';
      })
      .catch(err => {
        console.error('Cart error, redirecting directly:', err);
        window.location.href = isEnglish ? `/cart/${selectedVariantId}:1?locale=en` : `/cart/${selectedVariantId}:1`;
      });
  }

  if (heroCtaBtn) {
    heroCtaBtn.addEventListener('click', (e) => {
      e.preventDefault();
      proceedToCheckout(heroCtaBtn);
    });
  }

  if (floatingCtaBtn) {
    floatingCtaBtn.addEventListener('click', (e) => {
      e.preventDefault();
      proceedToCheckout(floatingCtaBtn);
    });
  }

  // 3. FAQ ACCORDION
  const faqQuestions = document.querySelectorAll('.faq-question');
  faqQuestions.forEach(btn => {
    btn.addEventListener('click', () => {
      const parent = btn.parentElement;
      const isActive = parent.classList.contains('active');

      // Close all others
      document.querySelectorAll('.faq-item').forEach(item => {
        item.classList.remove('active');
      });

      if (!isActive) {
        parent.classList.add('active');
      }
    });
  });

  // 4. LIVE URGENCY COUNTDOWN TIMER
  let totalSeconds = 14 * 60 + 52;
  const promoTimer = document.getElementById('promo-timer');
  const cMin = document.getElementById('c-min');
  const cSec = document.getElementById('c-sec');

  function updateTimer() {
    if (totalSeconds <= 0) {
      totalSeconds = 15 * 60; // reset loop
    }
    totalSeconds--;
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;

    const formattedM = mins.toString().padStart(2, '0');
    const formattedS = secs.toString().padStart(2, '0');

    if (promoTimer) promoTimer.textContent = `${formattedM}:${formattedS}`;
    if (cMin) cMin.textContent = formattedM;
    if (cSec) cSec.textContent = formattedS;
  }

  setInterval(updateTimer, 1000);
  updateTimer();

  // 5. STICKY FLOATING CTA BAR VISIBILITY ON SCROLL
  const floatingBar = document.getElementById('floating-bar');
  const heroSection = document.querySelector('.section-hero');

  window.addEventListener('scroll', () => {
    if (!floatingBar || !heroSection) return;
    const heroBottom = heroSection.getBoundingClientRect().bottom;
    if (heroBottom < 100) {
      floatingBar.classList.add('visible');
    } else {
      floatingBar.classList.remove('visible');
    }
  });

  // 6. WRITE REVIEW MODAL
  const modal = document.getElementById('review-modal');
  const openModalBtn = document.getElementById('open-review-modal');
  const closeModalBtn = document.getElementById('close-review-modal');

  if (openModalBtn && modal) {
    openModalBtn.addEventListener('click', () => modal.classList.add('active'));
  }
  if (closeModalBtn && modal) {
    closeModalBtn.addEventListener('click', () => modal.classList.remove('active'));
  }
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.classList.remove('active');
    });
  }

  // 7. REVIEW THUMBS UP COUNTER
  const thumbBtns = document.querySelectorAll('.thumb-btn');
  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('voted')) return;
      const text = btn.textContent;
      const parts = text.split(' ');
      if (parts.length === 2) {
        const count = parseInt(parts[1], 10) + 1;
        btn.textContent = `${parts[0]} ${count}`;
        btn.classList.add('voted');
        btn.style.borderColor = 'var(--accent-green)';
        btn.style.color = 'var(--accent-green)';
      }
    });
  });

});
